let SbxApplication = require('./sxbApplication');

function User(userData) {
    let user = userData || {};
    this.securiboxId = user.id;
    this.email = user.email;
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.pictureUrl = user.pictureUrl;
    this.phoneNumber = user.phoneNumber;
    this.creationDate = new Date(user.creationDate);
    this.lastPasswordChangedDate = new Date(user.lastPasswordChangedDate);
    this.modificationDate = new Date(user.modificationDate);
    this.language = user.language;
    this.applications = user.applications !== undefined && user.applications !== null ? user.applications.map(a => new SbxApplication(a)): [];
}

module.exports = User;